// externals
import { RSAA } from 'redux-api-middleware';
import { nanoid } from 'nanoid';

// libraries
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';

// consts/enums
import * as types from '../actionTypes/docSyncActionTypes';

/**
 * Triggers the deferred document sync from VinSolutions CRM.
 *
 * The request always goes to the `docSyncFromVIN` BFF lambda, which mints an
 * OAuth bearer and hits the secure downstream `/syncDocuments/{dealXgId}`
 * endpoint. The downstream owns the doc-type registry lookup, so all configured
 * doc types (driver's licence, insurance card, and any future type) transfer.
 *
 * @param dealXgId - The DealXG ID for the deal
 * @param referrer - The referrer header value (e.g., 'Showroom' for SV, 'CMD' for MV)
 * @returns RSAA action to trigger the doc sync
 */
export const syncDocumentsFromVIN = (dealXgId: string, referrer: string, dealerId: number) => {
    const locHref = locHrefUtil.getLocHref();

    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, `docSyncFromVIN/${dealXgId}`);

    return {
        [RSAA]: {
            endpoint: bffApiUrlResult.url,
            method: 'POST',
            body: JSON.stringify({}),
            headers: {
                'Content-Type': 'application/json',
                'x-dr-referrer': referrer,
                'X-CoxAuto-Correlation-Id': nanoid(),
                'x-dr-dealer-id': dealerId
            },
            types: [types.DOC_SYNC_FROM_VIN_REQUEST, types.DOC_SYNC_FROM_VIN_SUCCESS, types.DOC_SYNC_FROM_VIN_FAILURE]
        }
    };
};
